export default __webpack_public_path__ + "static/media/img-0348-ukraine-premium-face.6ad24480.png";